import { WasteKind } from "encamp-prisma/generated/browser";

import { prettyPrintEnumValue } from "../utils/prettyPrintEnumValue";

/**
 * A waste stream's management program on its own, blank when no special
 * program applies.
 *
 * Blank rather than "RCRA" so a scan down a Management Program column (the
 * waste streams grid and its export) surfaces only the streams on a special
 * program. A null kind reads the same way, whether it was never derived or the
 * tenant's feature flag withholds it.
 *
 * This is the single place the "RCRA or null means no program" rule lives.
 */
export const prettyPrintWasteProgram = (wasteKind: WasteKind | null | undefined): string =>
  !wasteKind || wasteKind === WasteKind.RCRA ? "" : prettyPrintEnumValue(wasteKind);

/**
 * The programs in the order their labels read, which is how a column showing
 * the program sorts them, with no program first. Read off
 * `prettyPrintWasteProgram`, so a new `WasteKind` takes its place by its label.
 */
export const WASTE_PROGRAM_SORT_ORDER: readonly WasteKind[] = Object.values(WasteKind)
  .filter((kind) => prettyPrintWasteProgram(kind) !== "")
  .sort((a, b) => prettyPrintWasteProgram(a).localeCompare(prettyPrintWasteProgram(b)));

/** 0 for no program, then 1, 2, … in `WASTE_PROGRAM_SORT_ORDER`. */
export const wasteProgramSortRank = (wasteKind: WasteKind | null | undefined): number =>
  wasteKind ? WASTE_PROGRAM_SORT_ORDER.indexOf(wasteKind) + 1 : 0;
